/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_LedeInputs */

const en_hero_lede = /** @type {(inputs: Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One coach, one plan, and a time that fits your week. Pick it below.`)
};

const pl_hero_lede = /** @type {(inputs: Hero_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden trener, jeden plan i termin, który pasuje do Twojego tygodnia. Wybierz go poniżej.`)
};

/**
* | output |
* | --- |
* | "One coach, one plan, and a time that fits your week. Pick it below." |
*
* @param {Hero_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_lede = /** @type {((inputs?: Hero_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_lede(inputs)
	return en_hero_lede(inputs)
});